import * as React from "react";
const SvgSwitchRightOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M24 24H0V0h24z" />
    <path d="M15.5 15.38V8.62L18.88 12l-3.38 3.38M14 19l7-7-7-7v14zm-4 0V5l-7 7 7 7z" />
  </svg>
);
export default SvgSwitchRightOutlined;
